import React, { useEffect, useState } from "react";
import { fileUrl } from "../../../../services/config";
import { getApi } from "../../../../services/api/globalApi";
import { PiImageSquareFill, PiXFill } from "react-icons/pi";

const { forwardRef, useRef, useImperativeHandle } = React;

const ProductModal = forwardRef(({ handleProduct }, ref) => {
  const [showModal, setShowModal] = useState(false);

  useImperativeHandle(ref, () => ({
    showModal() {
      setShowModal(!showModal);
      window.scrollTo({ top: 0, behavior: "smooth" });
    },
    afterSubmit() {},
  }));

  const [productData, setProductData] = useState([]);

  const getFiles = async (params) => {
    const path = "admin/products";
    try {
      const response = await getApi({ path, params: { ...params } });
      console.log(response.data.result);
      setProductData(response?.data.result.data);
    } catch (error) {
      console.log(error);
    }
  };

  useEffect(() => {
    getFiles();
  }, []);

  const selectProduct = (item) => {
    console.log(item);
    handleProduct(item);
  };

  useEffect(() => {
    if (showModal) {
      document.body.style.overflow = "hidden";
    } else {
      document.body.style.overflow = "auto";
    }
  }, [showModal]);

  return (
    <>
      <div
        className={`fixed top-0 right-0 w-full h-full bg-black/40 transition-all z-50  ${
          !showModal && "hidden"
        }`}
      ></div>
      <div
        className={`w-[340px] md:w-[768px] py-4 max-h-[360px] overflow-hidden bg-white dark:bg-gray-900 mt-4 shadow-md z-[80] rounded-3xl p-4 transition-all fixed top-0 right-[50%] mr-[-170px] md:mr-[-384px] opacity-0 invisible ${
          showModal && "!mt-20 !opacity-100 !visible"
        }`}
      >
        <div className="w-full px-6 flex items-center justify-between py-4 border-b-2 dark:text-white">
          <h4>آخرین محصولات</h4>
          <PiXFill
            onClick={() => setShowModal(false)}
            size={30}
            className="text-red-400 transition-all hover:text-red-600 cursor-pointer"
          />
        </div>

        {productData?.length > 0 ? (
          <div className="relative overflow-x-auto shadow-md sm:rounded-lg mt-6 h-[240px] overflow-y-scroll">
            <table className="w-full text-sm text-left rtl:text-right text-gray-500 dark:text-gray-400">
              <thead className="text-xs text-gray-700 uppercase bg-gray-50 dark:bg-gray-700 dark:text-gray-400">
                <tr>
                  <th scope="col" className="px-16 py-3">
                    <span className="sr-only">عکس</span>
                  </th>
                  <th scope="col" className="px-6 py-3">
                    کالا
                  </th>
                  <th scope="col" className="px-6 py-3">
                    قیمت
                  </th>
                  <th scope="col" className="px-6 py-3">
                    تخفیف
                  </th>
                  <th scope="col" className="px-6 py-3">
                    عملیات
                  </th>
                </tr>
              </thead>
              <tbody>
                {productData.map((item, index) => {
                  return (
                    <tr
                      key={index}
                      className="bg-white border-b dark:bg-gray-800 dark:border-gray-700 hover:bg-gray-50 dark:hover:bg-gray-600"
                    >
                      <td className="p-2">
                        <img
                          src={
                            item.mainImage
                              ? `${fileUrl}files/medium_${item.mainImage}`
                              : require("./../../../../assets/images/userIcon.png")
                          }
                          className="w-16 h-16 max-w-full max-h-full rounded-xl"
                          alt="Apple Watch"
                        />
                      </td>
                      <td className="px-6 py-4 font-semibold text-gray-900 dark:text-white">
                        {item.name}
                      </td>
                      <td className="px-6 py-4 font-semibold text-gray-900 dark:text-white">
                        {item.basePrice}
                      </td>
                      <td className="px-6 py-4 font-semibold text-gray-900 dark:text-white">
                        {item.discountPrice}
                      </td>
                      <td className="px-6 py-4">
                        <button
                          onClick={() => selectProduct(item)}
                          className="font-medium text-blue-600 dark:text-blue-500 hover:underline"
                        >
                          افزودن
                        </button>
                      </td>
                    </tr>
                  );
                })}
              </tbody>
            </table>
          </div>
        ) : (
          <div className="flex items-center justify-center gap-2 py-4 w-full mt-6 text-gray-700">
            محصول یافت نشد
            <PiImageSquareFill size={50} />
          </div>
        )}
      </div>
    </>
  );
});
export default ProductModal;
